import { createI18n } from "@haohan/react-i18n";

import {
	I18nMessageKey as RootI18nMessageKey,
	storage as rootI18n
} from "@haohan/root-locales";

import {
	i18nMessages,
	I18nMessageKey as LocalI18nMessageKey
} from './messages/messages';

type I18nMessageKey = RootI18nMessageKey | LocalI18nMessageKey

const { useI18n, storage } = createI18n<I18nMessageKey>(
	i18nMessages, null, [rootI18n]
);
export { useI18n, storage };
export type { I18nMessageKey };
